<template>
  <v-row
    ref="filters"
    class="pr-3 pl-3"
  >
    <v-col
      cols="12"
      md="4"
      class="pb-0"
    >
      <v-select
        :attach="true"
        clearable
        v-model="woj"
        :items="provinces"
        item-text="jpt_nazwa_"
        return-object
        @change="getPRG('counties')"
        :label="$i18n.t('dashboard.offers.woj')"
        :no-data-text="$i18n.t('default.noDataText')"
        outlined
      />
    </v-col>
    <v-col
      cols="12"
      md="4"
      class="pb-0"
    >
      <v-select
        :attach="true"
        clearable
        v-model="powiat"
        :items="counties"
        item-text="jpt_nazwa_"
        return-object
        @change="getPRG('communes')"
        item-value="jpt_kod_je"
        :label="$i18n.t('dashboard.offers.pow')"
        :no-data-text="$i18n.t('default.noDataText')"
        outlined
        :disabled="!woj"
      />
    </v-col>
    <v-col
      cols="12"
      md="4"
      class="pb-0"
    >
      <v-select
        :attach="true"
        clearable
        v-model="gmina"
        :items="communes"
        :label="$i18n.t('dashboard.offers.gmi')"
        outlined
        return-object
        :disabled="!powiat"
        item-text="jpt_nazwa_"
        :no-data-text="$i18n.t('default.noDataText')"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      provinces: [],
      counties: [],
      communes: [],

      woj: undefined,
      powiat: undefined,
      gmina: undefined
    };
  },
  computed: {
    wpg() {
      return {
        woj: this.woj,
        pow: this.powiat,
        gmi: this.gmina
      };
    }
  },

  watch: {
    woj(newVal) {
      if (!newVal) {
        this.gmina = undefined;
        this.powiat = undefined;
      }
    },
    powiat(newVal) {
      if (!newVal) {
        this.gmina = undefined;
      }
    },
    wpg(value) {
      this.$emit('wpg', value);
    }
  },

  methods: {
    getPRG(level) {
      const woj = this.woj ? this.woj.jpt_kod_je : null;
      const pow = this.powiat ? this.powiat.jpt_kod_je : null;
      let payload = {
        level,
        params: {
          woj,
          pow
        }
      };
      if (woj) {
        this.$store.dispatch('getPRG', payload).then(r => {
          if (r.status === 200) {
            this[level] = r.data[level];
          }
        });
      }
    }
  },

  mounted() {
    this.$store
      .dispatch('getPRG', {
        level: 'provinces'
      })
      .then(r => {
        this.provinces = r.data.provinces;
      });
  }
};
</script>
